<template>
  <section id="geo_distance" class="content_wrap">
    <div class="geo_selecter">
    <p>表示範囲</p>
    <label class="select_wrap">
    <select v-model="geoDistance">
      <option value="0">距離を指定せず最新を表示</option>
      <option value="5">半径5km以内を表示</option>
      <option value="10">半径10km以内を表示</option> 
      <option value="15">半径15km以内を表示</option>
      <option value="50">半径50km以内を表示</option>
      <option value="100">半径100km以内を表示</option>
      <option value="300">半径300km以内を表示</option>
    </select>
    <i class="material-icons">keyboard_arrow_down</i>
    </label>
    </div>
    <div class="spinner_area">
      <pulse-loader :loading="isLoading" :color="'#ff6969'" :size="'12px'"></pulse-loader>
    </div>
  </section>
</template>

<script>
export default {
  // 初期値設定
  data() {
    return {
      geoDistance: 0,
      isLoading: false,
    };
  },
  props: {
  },
  methods: {
    getLocation() {
      this.isLoading = true;
      if (navigator.geolocation) {
        var self = this;
        this.geoDistance = Vue.prototype.$coords.geoDistance;
        navigator.geolocation.getCurrentPosition(
          function (position){
            console.log(position);
            let coords = position.coords;
            Vue.prototype.$coords.latitude = coords.latitude;
            Vue.prototype.$coords.longitude = coords.longitude;
            Vue.prototype.$coords.isAvailable = true;
            Vue.prototype.$coords.geoDistance = parseInt(self.geoDistance,10);
            self.isLoading = false;
          }.bind(this),
          function(error) {
            console.log(error);
            Vue.prototype.$coords.isAvailable = false;
            self.isLoading = false;
          }
        );
      } else {
        this.geoDistance = 0;
        Vue.prototype.$coords.isAvailable = false;
        this.isLoading = false;
        console.log('Your browser is not available to fetch the coordinates.');
      }
    },
  },
  watch: {
    geoDistance: function (newGeoDistance, oldGeoDistance) {
      if(newGeoDistance == "0") {
        Vue.prototype.$coords.isAvailable = false;
      } else {
        if(!Vue.prototype.$coords.isAvailable) {
          Vue.prototype.$coords.isAvailable = true;
        }
        Vue.prototype.$coords.geoDistance = parseInt(newGeoDistance,10);
      }
    }
  },
  created() {
    this.getLocation();
  }
};
</script>